import React, { FC } from 'react';
import { Grid } from '@material-ui/core';

import { BlockListProvider, SharePhotoProvider, QueryVariablesProvider } from 'providers';
import { useContent, useProtectedClient } from 'hooks';

import { Footer, Form, FormBody, Header } from 'features/sharing/components';
import { useCanShare } from 'features/content/hooks';

const Permalink: FC = () => {
  const { id } = useProtectedClient();
  const content = useContent();
  const showShare = useCanShare(content);

  const { content_id } = content;

  return (
    <QueryVariablesProvider value={{ content_id }}>
      <SharePhotoProvider>
        <BlockListProvider client_id={id}>
          <Form>
            <Header />

            <Grid container justify="center">
              <Grid item xs={12} lg={11}>
                <FormBody />
              </Grid>
            </Grid>

            {showShare && <Footer position="fixed" />}
          </Form>
        </BlockListProvider>
      </SharePhotoProvider>
    </QueryVariablesProvider>
  );
};

export default Permalink;
